import gql from "graphql-tag";

export const CREATE_PLANNED_TIME = gql`
  mutation createPlannedTime($input: PlannedTimeInput!) {
    createPlannedTime(input: $input) {
      status
      error
      data {
        occurrences {
          id
          periodAndRecurrenceId
          projectId
          userId
          duration
          date
          active
          projectRoleId
          tentative
          notes
        }
        createdCount
        adjustedCount
        skippedCount
        adjustedDates
        skippedDates
      }
    }
  }
`;

export const UPDATE_PLANNED_TIME = gql`
  mutation updatePlannedTime($input: PlannedTimeUpdateInput!) {
    updatePlannedTime(input: $input) {
      status
      error
      data {
        id
        userId
        projectId
        projectRoleId
        startDate
        endDate
        frequency
        repeatEndDate
        durationPerDay
        active
        tentative
        notes
      }
    }
  }
`;

export const UPDATE_PLANNED_TIME_OCCURRENCE = gql`
  mutation updatePlannedTimeOccurrence(
    $input: UpdatePlannedTimeOccurrenceInput!
  ) {
    updatePlannedTimeOccurrence(input: $input) {
      status
      error
      data {
        id
        periodAndRecurrenceId
        projectId
        userId
        duration
        date
        active
        projectRoleId
        tentative
        notes
      }
    }
  }
`;

export const DELETE_PLANNED_TIME = gql`
  mutation deletePlannedTime($id: ID!) {
    deletePlannedTime(id: $id) {
      status
      error
      data
    }
  }
`;

export const DELETE_PLANNED_TIME_OCCURRENCE = gql`
  mutation deletePlannedTimeOccurrence($id: ID!) {
    deletePlannedTimeOccurrence(id: $id) {
      status
      error
      data
    }
  }
`;

export const CREATE_TIME_OFF = gql`
  mutation createTimeOff($input: TimeOffInput!) {
    createTimeOff(input: $input) {
      status
      error
      data {
        occurrences {
          id
          periodAndRecurrenceId
          userId
          duration
          date
          active
          type
        }
        reducedPlannedTimeIds
        deletedPlannedTimeIds
        adjustedDates
        skippedDates
      }
    }
  }
`;

export const UPDATE_TIME_OFF = gql`
  mutation updateTimeOff($input: TimeOffUpdateInput!) {
    updateTimeOff(input: $input) {
      status
      error
      data {
        id
        userId
        startDate
        endDate
        frequency
        repeatEndDate
        durationPerDay
        active
        type
      }
    }
  }
`;

export const DELETE_TIME_OFF = gql`
  mutation deleteTimeOff($id: ID!) {
    deleteTimeOff(id: $id) {
      status
      error
      data
    }
  }
`;

export const UPDATE_TIME_OFF_OCCURRENCE = gql`
  mutation updateTimeOffOccurrence($input: UpdateTimeOffOccurrenceInput!) {
    updateTimeOffOccurrence(input: $input) {
      status
      error
      data {
        id
        periodAndRecurrenceId
        userId
        duration
        date
        active
        type
      }
    }
  }
`;

export const DELETE_TIME_OFF_OCCURRENCE = gql`
  mutation deleteTimeOffOccurrence($id: ID!) {
    deleteTimeOffOccurrence(id: $id) {
      status
      error
      data
    }
  }
`;
